import {
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";

interface PartDetailCardProps {
  title: string;
  text: string;
  color: string;
  isFlagged?: boolean;
  isAdminFlagged?: boolean;
  onFlaggedChange?: () => void;
  canEdit?: boolean;
}

const PartDetailCard = ({
  title,
  text,
  color,
  isFlagged = false,
  isAdminFlagged = false,
  onFlaggedChange,
  canEdit = false,
}: PartDetailCardProps) => {
  const textDetial = (
    <Typography
      variant="body2"
      sx={{
        fontWeight: "500",
        color: "white",
        fontSize: "1.25rem",
        pr: 2,
      }}
    >
      {text}
    </Typography>
  );

  const flagButton = (
    <Tooltip
      title={"Flag"}
      placement="top"
      slotProps={{
        popper: {
          modifiers: [{ name: "offset", options: { offset: [0, -10] } }],
        },
      }}
    >
      <IconButton disabled={!canEdit} onClick={onFlaggedChange}>
        <FlagIcon
          sx={{
            color: isFlagged
              ? isAdminFlagged
                ? "success.light"
                : "error.main"
              : "action.disabled",
          }}
        />
      </IconButton>
    </Tooltip>
  );

  return (
    <Card
      sx={{
        width: "100%",
        minHeight: 55,
        borderRadius: 2,
        backgroundColor: color,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: text === "flagged" ? 1 : 2,
        }}
      >
        {" "}
        <Typography
          variant="body2"
          sx={{
            fontWeight: "500",
            color: "white",
            fontSize: "1.25rem",
            pt: 0,
          }}
        >
          {title}
        </Typography>
        {text === "flagged" ? flagButton : textDetial}
      </CardContent>
    </Card>
  );
};

export default PartDetailCard;
